import React, { useContext } from 'react';
import routes from '../../../constants/Routes';
import { useHistory } from 'react-router-dom';
import useNewChatbotBody from './hooks/useNewChatbotBody';
import { useSelector } from 'react-redux';
import CONSTANT from '../../../constants/Constant';

const NewChatbotCompletedScreen = () => {
    const history = useHistory();
    const { handleCloseChatbotNew } = useNewChatbotBody();
    const chatBotNewState = useSelector((state) => state.chatBotNew);
    const { invitationTypeName } = chatBotNewState;

    const getMessage = () => {
        const invitationType = (invitationTypeName || '').toLowerCase();

        if (invitationType === CONSTANT.REDIRECT_TYPE.INCLINIC) {
            return "Thank you for completing your assessment. Please be available at your scheduled clinic time.";
        } else if (invitationType === CONSTANT.REDIRECT_TYPE.TELEMEDICINE) {
            return "Thank you for completing your assessment. Please join the appointment at the scheduled time.";
        } else {
            // Self-assessment
            return "Thank you for completing your assessment! Your personalized performance report is ready.";
        }
    };

    const handleOK = () => {
        handleCloseChatbotNew();
        history.push(`${routes.myAssessments}/false`, { refresh: true });
    };

    return (
        <div className="mmh-callout">
            <div className="mmh-callout__body">
                <div className="mmh-callout__content">
                    <h3 className="mmh-callout__title">Assessment Complete</h3>
                    <div className="mmh-callout__desc">
                        <span className="mmh-font-xl">
                            {getMessage()}
                        </span>
                        <br />
                        <button
                            type="button"
                            className="ok-btn mmh-mt-10"
                            onClick={handleOK}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewChatbotCompletedScreen;
